module.exports = "/images/vendor/jquery-ui-dist/ui-icons_cc0000_256x240.png?093a819138276b446611d1d2a45b98a2";